@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.credit-card-payment-message {
  font-size: 12px;
  color: @wallet--default--text-color;
  margin-top: 8px;
}
